const actions = {
  LIST_REQUEST: "TLL_BULK_RESERVATION_SETTING/LIST_REQUEST",
  LIST_SUCCESS: "TLL_BULK_RESERVATION_SETTING/LIST_SUCCESS",
  LIST_ERROR: "TLL_BULK_RESERVATION_SETTING/LIST_ERROR",

  SEARCH_REQUEST: "TLL_BULK_RESERVATION_SETTING/SEARCH_REQUEST",
  SEARCH_SUCCESS: "TLL_BULK_RESERVATION_SETTING/SEARCH_SUCCESS",
  SEARCH_ERROR: "TLL_BULK_RESERVATION_SETTING/SEARCH_ERROR",

  CREATE_REQUEST: "TLL_BULK_RESERVATION_SETTING/CREATE_REQUEST",
  CREATE_SUCCESS: "TLL_BULK_RESERVATION_SETTING/CREATE_SUCCESS",
  CREATE_ERROR: "TLL_BULK_RESERVATION_SETTING/CREATE_ERROR",

  DETAIL_REQUEST: "TLL_BULK_RESERVATION_SETTING/DETAIL_REQUEST",
  DETAIL_SUCCESS: "TLL_BULK_RESERVATION_SETTING/DETAIL_SUCCESS",
  DETAIL_ERROR: "TLL_BULK_RESERVATION_SETTING/DETAIL_ERROR",

  UPDATE_REQUEST: "TLL_BULK_RESERVATION_SETTING/UPDATE_REQUEST",
  UPDATE_SUCCESS: "TLL_BULK_RESERVATION_SETTING/UPDATE_SUCCESS",
  UPDATE_ERROR: "TLL_BULK_RESERVATION_SETTING/UPDATE_ERROR",

  DELETE_REQUEST: "TLL_BULK_RESERVATION_SETTING/DELETE_REQUEST",
  DELETE_SUCCESS: "TLL_BULK_RESERVATION_SETTING/DELETE_SUCCESS",
  DELETE_ERROR: "TLL_BULK_RESERVATION_SETTING/DELETE_ERROR",

  EXECUTE_REQUEST: "TLL_BULK_RESERVATION_SETTING/EXECUTE_REQUEST",
  EXECUTE_SUCCESS: "TLL_BULK_RESERVATION_SETTING/EXECUTE_SUCCESS",
  EXECUTE_ERROR: "TLL_BULK_RESERVATION_SETTING/EXECUTE_ERROR",

  CANCEL_REQUEST: "TLL_BULK_RESERVATION_SETTING/CANCEL_REQUEST",
  CANCEL_SUCCESS: "TLL_BULK_RESERVATION_SETTING/CANCEL_SUCCESS",
  CANCEL_ERROR: "TLL_BULK_RESERVATION_SETTING/CANCEL_ERROR",

  CURRENT_REQUEST: "TLL_BULK_RESERVATION_SETTING/CURRENT_REQUEST",
  CURRENT_SUCCESS: "TLL_BULK_RESERVATION_SETTING/CURRENT_SUCCESS",
  CURRENT_ERROR: "TLL_BULK_RESERVATION_SETTING/CURRENT_ERROR",

  HISTORIES_REQUEST: "TLL_BULK_RESERVATION_SETTING/HISTORIES_REQUEST",
  HISTORIES_SUCCESS: "TLL_BULK_RESERVATION_SETTING/HISTORIES_SUCCESS",
  HISTORIES_ERROR: "TLL_BULK_RESERVATION_SETTING/HISTORIES_ERROR",

  RESET_DETAIL: "TLL_BULK_RESERVATION_SETTING/RESET_DETAIL",

  list: (payload) => ({
    type: actions.LIST_REQUEST,
    payload,
  }),

  search: (payload) => ({
    type: actions.SEARCH_REQUEST,
    payload,
  }),

  create: (payload) => ({
    type: actions.CREATE_REQUEST,
    payload,
  }),

  getDetail: (payload) => ({
    type: actions.DETAIL_REQUEST,
    payload,
  }),

  update: (payload) => ({
    type: actions.UPDATE_REQUEST,
    payload,
  }),

  delete: (payload) => ({
    type: actions.DELETE_REQUEST,
    payload,
  }),

  execute: (payload) => ({
    type: actions.EXECUTE_REQUEST,
    payload,
  }),

  cancel: (payload) => ({
    type: actions.CANCEL_REQUEST,
    payload,
  }),

  getCurrent: (payload) => ({
    type: actions.CURRENT_REQUEST,
    payload,
  }),

  getHistories: (payload) => ({
    type: actions.HISTORIES_REQUEST,
    payload,
  }),

  resetDetail: () => ({
    type: actions.RESET_DETAIL,
  }),
};

export default actions;
